<template>
  <div :class="$style.container">
    <LoadingOverlay
      :hasBlur="false"
      isLight
      :visible="showLoader"
    />
    <div v-if="showDetails">
      <AndroidEmmEnrollmentInfo
        :detailsInfo="enrollmentInfo"
        :headerTitle="enrollmentInfoTitle"
      />
      <AndroidDeviceSectionInfo
        :class="$style.deviceState"
        :detailsInfo="deviceState"
        :headerTitle="deviceStateTitle"
      />
    </div>
  </div>
</template>

<script>
import { LoadingOverlay } from '@jumpcloud/ui-components';
import { mapState } from 'vuex';
import { notify } from 'client/util';
import AndroidDeviceSectionInfo from 'client/systems/AndroidDeviceSectionInfo';
import AndroidEmmEnrollmentInfo from 'client/systems/AndroidEmmEnrollmentInfo';
import Constants, { ItemTypeConsts, StoreModelMap } from 'client/util/Constants';
import DateUtil from 'client/util/DateUtil';
import GoogleMdmApi from 'client/api/v2/GoogleMdmApi';

const { error } = Constants;
const systemModel = StoreModelMap[ItemTypeConsts.device];

export default {
  name: 'AndroidEmm',

  components: {
    AndroidDeviceSectionInfo,
    AndroidEmmEnrollmentInfo,
    LoadingOverlay,
  },

  data: () => ({
    deviceState: {},
    deviceStateTitle: 'Device State',
    enrollmentInfo: {},
    enrollmentInfoTitle: 'EMM Enrollment Info',
    showDetails: false,
    showLoader: true,
  }),

  computed: {
    ...mapState(systemModel, [
      'item',
    ]),
  },

  mounted() {
    this.fetchAndroidDeviceDetails();
  },

  methods: {
    async fetchAndroidDeviceDetails() {
      try {
        const deviceDetailsRsp = await GoogleMdmApi.getDeviceDetails(
          this.item.mdm.internal.deviceId,
        );
        this.deviceState = deviceDetailsRsp.deviceInformation.deviceStateInfo;
        this.enrollmentInfo = deviceDetailsRsp.deviceInformation.emmEnrollmentInfo;
        this.enrollmentInfo.appliedPolicyName = this.formattedValue(
          deviceDetailsRsp.deviceInformation.emmEnrollmentInfo.appliedPolicyName,
        );
        this.enrollmentInfo.policyName = this.formattedValue(
          deviceDetailsRsp.deviceInformation.emmEnrollmentInfo.policyName,
        );
        this.enrollmentInfo.enrollmentTime = DateUtil.formatDateTime(
          new Date(this.enrollmentInfo.enrollmentTime),
        );
        this.showLoader = false;
        this.showDetails = true;
      } catch (err) {
        notify(error, 'Something went wrong.');
        this.showLoader = false;
      }
    },

    formattedValue(value) {
      const nameSplitList = value.split('/');
      const formatValue = nameSplitList[nameSplitList.length - 1];
      return formatValue;
    },
  },
};
</script>

<style module>
.container {
  height: 100%;
  overflow: auto;
  padding: 0.625rem 1.25rem 0.625rem;
  width: 100%;
}

.deviceState {
  margin-top: var(--jc-spacer);
}
</style>
